import {useEffect, useId} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {makeSelectIsVisibleRenderedModal} from '@/state/selectors/modal';
import {addModalToRenderedModals, removeModalFromRenderedModals} from '@/state/slices/modalSlice';

const useOneModalOnPageAtATime = ({allowDisplayWithOtherPopups, isOpen = true} = {}) => {
    const modalId = useId();
    const dispatch = useDispatch();
    const isVisibleModal = useSelector(makeSelectIsVisibleRenderedModal(modalId));

    useEffect(() => {
        if (!isOpen) return;
        if (allowDisplayWithOtherPopups) return;

        dispatch(addModalToRenderedModals(modalId));

        return () => {
            dispatch(removeModalFromRenderedModals(modalId));
        };
    }, [isOpen]);

    return allowDisplayWithOtherPopups || isVisibleModal;
};

export default useOneModalOnPageAtATime;
